<div class="row row-sm add-form min">
  <div class="col-lg-12">
    <div class="card-body">
      <div class="bc d-flex align-items-center pl-3 mb-3">
        <img src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2" />
        <div class="ml-2">
          <h3 class="main-content-label mb-1">
            <b>
              {{
                data.key === 'Add'
                  ? ("header.TeacherEligibilityDialogBoxComponent.title" | translate)
                  : data.key === 'Edit'
                  ? ("header.TeacherEligibilityDialogBoxComponent.title" | translate)
                  : ("header.TeacherEligibilityDialogBoxComponent.title" | translate)
              }}
            </b>
          </h3>
          <p class="text-muted mb-0">
            {{
              data.key === 'Add'
                ? ("header.TeacherEligibilityDialogBoxComponent.titleList.AddNewRecord" | translate)
                : data.key === 'Edit'
                ? ("header.TeacherEligibilityDialogBoxComponent.titleList.UpdateRecord" | translate)
                : ("header.TeacherEligibilityDialogBoxComponent.titleList.DeleteRecord" | translate)
            }}
          </p>
        </div>
      </div>
      <form [formGroup]="teacherAssignForm">
        <div class="row mt-3">
          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>Faculty</mat-label>

                <mat-select
                  #facultySelect
                  formControlName="Faculty"
                  [disabled]="isread || isreaddelete"
                  required
                  (selectionChange)="onFacultyChange()">
                  <mat-select-filter
                    *ngIf="facultySelect.focused"
                    [placeholder]="'Search Faculty'"
                    [displayMember]="'FcDesc'"
                    [array]="facultyList"
                    (filteredReturn)="filteredFacultyList = $event">
                  </mat-select-filter>
                  <mat-option
                    *ngFor="let item of filteredFacultyList"
                    [value]="item.FcCode + ''">
                    {{ item.FcDesc }}
                  </mat-option>

                </mat-select>

                <mat-error
                  *ngIf="teacherAssignForm.get('Faculty')?.hasError('required') &&
                        teacherAssignForm.get('Faculty')?.touched">
                  Faculty is required
                </mat-error>
              </mat-form-field>

          </div>

          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Course</mat-label>

              <mat-select
                #courseSelect
                formControlName="CoCode"
                [disabled]="isread || isreaddelete"
                required
                (selectionChange)="onCourseChange()">
                <mat-select-filter
                  *ngIf="courseSelect.focused"
                  [placeholder]="'Search Course'"
                  [displayMember]="'CoName'"
                  [array]="courseList"
                  (filteredReturn)="filteredCourseList = $event">
                </mat-select-filter>
                <mat-option
                  *ngFor="let item of filteredCourseList"
                  [value]="item.CoCode + ''">
                  {{ item.CoName }}
                </mat-option>

              </mat-select>

              <mat-error
                *ngIf="teacherAssignForm.get('CoCode')?.hasError('required') &&
                      teacherAssignForm.get('CoCode')?.touched">
                Course is required
              </mat-error>
            </mat-form-field>

          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
           <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>Subject</mat-label>
                <mat-select
                  #subjectSelect
                  formControlName="SubId"
                  [disabled]="isread || isreaddelete">
                  <mat-select-filter
                    *ngIf="subjectSelect.focused"
                    [placeholder]="'Search Subject'"
                    [displayMember]="'SubName'"
                    [array]="subjectList"
                    (filteredReturn)="filteredSubjectList = $event">
                  </mat-select-filter>
                  <mat-option
                    *ngFor="let item of filteredSubjectList"
                    [value]="item.SubId + ''">
                    {{ item.SubName }}
                  </mat-option>

                </mat-select>
              </mat-form-field>
          </div>
          
          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Designation</mat-label>
              <mat-select
                formControlName="Designation"
                [disabled]="isread || isreaddelete"
                required
              >
                <mat-option [value]="null" disabled>
                  -- Select Designation --
                </mat-option>
                <mat-option value="INT">Internal</mat-option>
                <mat-option value="EXT">External</mat-option>
                <mat-option value="CP">Chair Person</mat-option>
              </mat-select>
              <mat-error *ngIf="teacherAssignForm.get('Designation')?.hasError('required') && teacherAssignForm.get('Designation')?.touched">
                Designation is required
              </mat-error>
            </mat-form-field>
          </div>
<div class="col-lg-2 col-md-4 col-sm-6">
  <mat-form-field appearance="outline" class="example-full-width">
    <mat-label>
      {{ "header.TeacherEligibilityDialogBoxComponent.form.CourseLevel" | translate }}
    </mat-label>
    <mat-select 
      formControlName="CoLevel"
      [disabled]="isread || isreaddelete"
      required
    >
      <mat-option [value]="null" disabled>
        -- {{ "header.TeacherEligibilityDialogBoxComponent.form.CourseLevel" | translate }} --
      </mat-option>
      <mat-option *ngFor="let item of filteredCourseLevelList" [value]="item.CdCode">
        {{item.CdDesc}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="teacherAssignForm.get('CoLevel')?.hasError('required') && teacherAssignForm.get('CoLevel')?.touched">
      {{ "header.TeacherEligibilityDialogBoxComponent.form.CourseLevel" | translate }} is required
    </mat-error>
  </mat-form-field>
</div>
  
          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Experience</mat-label>
              <input 
                matInput 
                type="number" 
                formControlName="Experience" 
                [readonly]="isreaddelete"
                min="0"
              />
              <mat-error *ngIf="teacherAssignForm.get('Experience')?.hasError('required') && teacherAssignForm.get('Experience')?.touched">
                Experience is required
              </mat-error>
              <mat-error *ngIf="teacherAssignForm.get('Experience')?.hasError('min')">
                Experience must be 0 or more
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Count</mat-label>
              <input 
                matInput 
                type="number" 
                formControlName="Count" 
                [readonly]="isreaddelete"
                min="1"
              />
              <mat-error *ngIf="teacherAssignForm.get('Count')?.hasError('required') && teacherAssignForm.get('Count')?.touched">
                Count is required
              </mat-error>
              <mat-error *ngIf="teacherAssignForm.get('Count')?.hasError('min')">
                Count must be 1 or more
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>District</mat-label>
              <mat-select
                formControlName="District"
                [disabled]="isreaddelete"
                required
              >
                <mat-option [value]="null" disabled>
                  -- Select District --
                </mat-option>
                <mat-option value="Local">Local</mat-option>
                <mat-option value="Outer">Outer</mat-option>
              </mat-select>
              <mat-error *ngIf="teacherAssignForm.get('District')?.hasError('required') && teacherAssignForm.get('District')?.touched">
                District is required
              </mat-error>
            </mat-form-field>
          </div>
          
          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Is Repeat</mat-label>
              <mat-select
                formControlName="Is_Repeat"  
                [disabled]="isreaddelete"
              >
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Teacher Type</mat-label>
              <mat-select
                formControlName="TeacherType"
                [disabled]="isreaddelete"
                required
              >
                <mat-option [value]="null" disabled>
                  -- Select Teacher Type --
                </mat-option>
                <mat-option
                  *ngFor="let item of filteredTeacherTypeList" 
                  [value]="item.CdCode"
                >
                  {{ item.CdDesc }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="teacherAssignForm.get('TeacherType')?.hasError('required') && teacherAssignForm.get('TeacherType')?.touched">
                Teacher Type is required
              </mat-error>
            </mat-form-field>
          </div>
          
          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Is HOD</mat-label>
              <mat-select
                formControlName="IsHOD"
                [disabled]="isreaddelete"
              >
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
      
          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Is Same College</mat-label>
              <mat-select
                formControlName="IsSameCollege"
                [disabled]="isreaddelete"
              >
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
         
          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Is Both Teach Type</mat-label>
              <mat-select
                formControlName="IsBothTeachType"
                [disabled]="isreaddelete"
              >
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Is Guide</mat-label>
              <mat-select
                formControlName="Guide"
                [disabled]="isreaddelete"
              >
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>Is Not Same Distirct</mat-label>
              <mat-select
                formControlName="IsNotSameDistirct"
                [disabled]="isreaddelete"
              >
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </form>
      

      <div class="row mt-2">
        <div class="col-12 d-flex justify-content-end align-items-center">
          <button
            type="button"
            (click)="closeDialog()"
            class="btn btn-primary btn-icon-text mr-2"
          >
            <span style="display: inline-flex; align-items: center">
              <img
                width="20vh"
                src="../../assets/img/turn-left.gif"
                style="margin-right: 7px"
              />
              {{ "header.TeacherEligibility.titleList.Back" | translate }}
            </span>
          </button>
          <button
            *ngIf="submitButton"
            type="button"
            (click)="submit()"
            class="btn btn-primary btn-icon-text mr-2"
          >
            <img
              width="20vh"
              src="../../assets/img/save.gif"
              style="margin-right: 7px"
            />
            {{ "header.TeacherEligibilityDialogBoxComponent.buttons.Save" | translate }}
          </button>
          <button
            *ngIf="editButton"
            type="button"
            (click)="update()"
            class="btn btn-primary btn-icon-text mr-2"
          >
            <img
              width="20vh"
              src="../../assets/img/save.gif"
              style="margin-right: 7px"
            />
            {{ "header.TeacherEligibilityDialogBoxComponent.buttons.Update" | translate }}
          </button>
          <button
            *ngIf="deleteButton"
            type="button"
            (click)="deleteRecord()"
            class="btn btn-danger btn-icon-text"
          >
            <img
              width="20vh"
              src="../../assets/img/trash.gif"
              style="margin-right: 7px"
            />
            {{ "header.TeacherEligibilityDialogBoxComponent.buttons.Delete" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>